type TokenPayload = {
  health_coach_id?: string | null;
  health_coach_role?: string | null;
  [key: string]: unknown;
};

const TOKEN_STORAGE_KEY = "token";

const safeBase64Decode = (value: string) => {
  try {
    const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
    return atob(normalized);
  } catch (error) {
    console.error("Invalid token base64 value", error);
    return null;
  }
};

export const getTokenPayload = (): TokenPayload | null => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!token) {
    return null;
  }
  const parts = token.split(".");
  if (parts.length < 2) {
    return null;
  }
  const decoded = safeBase64Decode(parts[1]);
  if (!decoded) {
    return null;
  }
  try {
    return JSON.parse(decoded);
  } catch (error) {
    console.error("Unable to parse token payload", error);
    return null;
  }
};

export const getHealthCoachFromToken = () => {
  const payload = getTokenPayload();
  if (!payload) {
    return { health_coach_id: null, health_coach_role: null };
  }
  return {
    health_coach_id: payload.health_coach_id ?? null,
    health_coach_role: payload.health_coach_role ?? null,
  };
};
